function checkWizzyConfigAndUpdate() {
  window.wizzyConfig &&
  (window.matchMedia("(max-width: 768px)").matches
    ? (window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] =
        {
          dom: ".wizzy-search-form-wrapper #searchInput",
          type: "search",
        })
    : (window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] =
        {
          dom: ".header-desktop #searchInput",
          type: "search",
        }));
  clearInterval(interval);
}
var interval = setInterval(checkWizzyConfigAndUpdate, 100);

const prohibitedWords = ["bitch","blood","bloody", "illegal","black market","unlicensed","counterfeit","smuggle","smuggling","weapon","violence","riot","fraudulent","shit"];

const targetNode = document.querySelector(".wizzy-body-end-wrapper");
function updateBodyClass() {
  const autocompleteElement = targetNode?.querySelector(
    ".wizzy-autocomplete-wrapper"
  );
  const isOpen =
    autocompleteElement &&
    window.getComputedStyle(autocompleteElement).display === "flex";

  if (isOpen) {
    document.body.classList.add("wizzy-autocomplete-open");
    document.documentElement.classList.add("wizzy-autocomplete-open");
    // lockScroll();
  } else {
    document.body.classList.remove("wizzy-autocomplete-open");
    document.documentElement.classList.remove("wizzy-autocomplete-open");
    // unlockScroll();
  }
}

const config = {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ["style"],
};

const callback = function (mutationsList, observer2) {
  for (const mutation of mutationsList) {
    updateBodyClass();
    break;
  }
};

const observer = new MutationObserver(callback);
if (targetNode) {
  observer.observe(targetNode, config);
  updateBodyClass();
}

if (window.innerWidth < 768) {
  const input = document.querySelector(
    ".wizzy-search-form-wrapper #searchInput"
  );
  if (input) {
    input.addEventListener(
      "touchstart",
      (e) => {
        e.stopPropagation();
      },
      { passive: true }
    );

    input.addEventListener(
      "touchmove",
      (e) => {
        e.preventDefault();
        e.stopPropagation();
      },
      { passive: false }
    );
  }

  const searchFormWrapper = document.querySelector(
    ".wizzy-search-form-wrapper.mobileTapped"
  );
  if (searchFormWrapper) {
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    document.documentElement.style.overflow = "hidden";
  }

  // if (window.visualViewport) {
  //   const adjustWrapperHeight = () => {
  //     const wrapper = document.querySelector(".wizzy-autocomplete-wrapper");
  //     const input = document.querySelector(
  //       ".wizzy-search-form-wrapper #searchInput"
  //     );

  //     if (!wrapper || !input) return;

  //     const inputRect = input.getBoundingClientRect();
  //     const availableHeight =
  //       window.visualViewport.height - inputRect.bottom - 10 + 50;

  //     const isKeyboardOpen =
  //       window.visualViewport.height < window.innerHeight * 0.75;

  //     if (isKeyboardOpen) {
  //       wrapper.style.maxHeight = `${availableHeight}px`;
  //       wrapper.style.overflowY = "auto";
  //     } else {
  //       wrapper.style.maxHeight = "";
  //       wrapper.style.overflowY = "";
  //     }
  //   };

  //   window.visualViewport.addEventListener("resize", adjustWrapperHeight);
  //   window.visualViewport.addEventListener("scroll", adjustWrapperHeight);

  //   const observer = new MutationObserver(() => {
  //     adjustWrapperHeight();
  //   });

  //   const wrapper = document.querySelector(".wizzy-autocomplete-wrapper");
  //   if (wrapper) {
  //     observer.observe(wrapper, {
  //       childList: true,
  //       subtree: true,
  //     });
  //   }

  //   const input = document.querySelector(
  //     ".wizzy-search-form-wrapper #searchInput"
  //   );
  //   if (input) {
  //     input.addEventListener("input", () => {
  //       setTimeout(adjustWrapperHeight, 1000);
  //       const autocompleteTextWrappers = document.querySelectorAll(
  //         ".autocomplete-text-wrapper"
  //       );

  //       if (autocompleteTextWrappers.length > 0) {
  //         autocompleteTextWrappers.forEach((wrapper) => {
  //           wrapper.addEventListener("click", (e) => {
  //             setTimeout(() => {
  //               adjustWrapperHeight();
  //             }, 1000);
  //           });
  //         });
  //       }
  //     });
  //   }
  // }
}

// window.addEventListener("load", function () {
//   const searchButtons = document.querySelectorAll(
//     ".header__secondary-nav [href='/search']"
//   );
//   if (searchButtons) {
//     searchButtons.forEach((btn) => {
//       btn.style.pointerEvents = "auto";
//     });
//   }
// });

window.addEventListener("scroll", () => {
  const autocompleteWrapper = document.querySelector(
      ".wizzy-autocomplete-wrapper"
    ),
    searchInput = document.querySelector(".header-desktop #searchInput");
  const body = document.body;
  if (window.innerWidth > 768) {
    if (window.scrollY == 0) {
      if (body.classList.contains("wizzy-autocomplete-scrolled")) {
        body.classList.remove("wizzy-autocomplete-scrolled");
      }
    } else {
      body.classList.add("wizzy-autocomplete-scrolled");
    }
  }
});

function fetchPages(queryHit, cursor = null) {
  // GraphQL query
  const query = `
              query {search(query: "${queryHit}", first: 12, after: ${
    cursor ? `"${cursor}"` : "null"
  }, types: [PAGE]) {
                pageInfo {
                  hasNextPage
                  hasPreviousPage
                }
                edges {
                  cursor
                  node {
                    ... on Page {
                      id
                      title
                      handle
                    }
                  }
                }
              }
            }
            `;

  fetch("https://pavingzone.myshopify.com/api/graphql", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": "e747886c67e2d420d05516f8dcc15795",
    },
    body: JSON.stringify({
      query: query,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data && data.data.search && data.data.search.edges) {
        const pageList = document.querySelector(".wizzy-page-list");
        const pageWrapper = document.querySelector(".wizzy-page-wrapper");
        if (data.data.search.edges.length <= 0) {
          pageWrapper.innerHTML = `<div class="wizzy-empty-results-content"><h2>We couldn't find any Pages!</h2></div>`;
        } else {
          data.data.search.edges.forEach((edge) => {
            const page = edge.node;
            const pageHtml = `<li><a href="/pages/${page.handle}" class="link-reverse">${page.title}</a></li>`;
            pageList.innerHTML += pageHtml;
          });
        }
        const pageInfo = data.data.search.pageInfo;

        if (pageInfo.hasNextPage) {
          nextPageCursor =
            data.data.search.edges[data.data.search.edges.length - 1].cursor;
          hasNextPage = true;
        } else {
          hasNextPage = false;
        }
      } else {
        // console.error("Error: Unable to retrieve articles", data);
      }
    })
    .catch((error) => {
      // console.error("Error:", error);
    });
}

function fetchArticles(queryHit, cursor = null) {
  // GraphQL query
  const query = `
  query {
    articles(
      first: 12,
      query: "${queryHit}",
      sortKey: RELEVANCE,
      after: ${cursor ? `"${cursor}"` : "null"}
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          id
          title
          onlineStoreUrl
          handle
          excerpt
          excerptHtml
          content
          contentHtml
          publishedAt
          tags
          authorV2 {
            name
          }
          blog {
            handle
            title
          }
          image {
            url
            altText
            width
            height
          }
        }
      }
    }
  }
`;

  fetch("https://pavingzone.myshopify.com/api/graphql", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": "e747886c67e2d420d05516f8dcc15795", // Replace with your actual access token
    },
    body: JSON.stringify({
      query: query,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data && data.data && data.data.articles) {
        const blogWrapper = document.querySelector(".wizzy-blog-wrapper");
        const blogList = document.querySelector(".blog-post-list");
        // Loop through the edges array from the fetched data
        if (data.data.articles.edges.length <= 0) {
          blogWrapper.innerHTML = `<div class="wizzy-empty-results-content"><h2>We couldn't find any Blog Post!</h2></div>`;
        } else {
          data.data.articles.edges.forEach((edge) => {
            const article = edge.node;
            const excerpt =
              article.excerpt && article.excerpt.trim().length > 0
                ? article.excerpt
                : article.contentHtml
                    .replace(/<[^>]+>/g, "")
                    .substring(0, 200) + "...";
            const category =
              article.tags && article.tags.length > 0 ? article.tags[0] : "";
            // Create the HTML structure for each article
            const articleHtml = `
            <div class="blog-post-card group snap-center">
              ${
                article.image
                  ? `
                  <a href="${article.onlineStoreUrl}" class="overflow-hidden">
                    <img 
                      src="${article.image.url}" 
                      alt="${article.image.altText || article.title}" 
                      width="${article.image.width || 1024}" 
                      height="${article.image.height || 683}" 
                      loading="lazy" 
                      sizes="(max-width: 699px) 95vw, (max-width: 1149px) calc(100vw / 2), calc((80rem - (5rem * (3 - 1) / 3)" 
                      class="blog-post-card__image w-full zoom-image group-hover:zoom"
                    >
                  </a>`
                  : `
                  <div class="overflow-hidden">
                    <div class="blog-post-card__image placeholder w-full"></div>
                  </div>`
              }

              <div class="blog-post-card__info">
                ${
                  category
                    ? `<a href="/blogs/${article.blog.handle}/tagged/${category
                        .toLowerCase()
                        .replace(/\s+/g, "-")}" 
                        class="blog-post-card__category h6 link-faded">
                        ${category}
                      </a>`
                    : ""
                }

                <p>
                  <a href="${
                    article.onlineStoreUrl
                  }" class="blog-post-card__title h4">
                    ${article.title}
                  </a>
                </p>

                ${
                  excerpt
                    ? `<p class="blog-post-card__excerpt">${excerpt}</p>`
                    : ""
                }

                <div class="st-product-author">
                  by ${article.authorV2?.name || "Unknown"}
                </div>

                <a href="${
                  article.onlineStoreUrl
                }" class="blog-post-card__read-more link">
                  Read more
                </a>
              </div>
            </div>
          `;

            // Append the generated HTML to the .wizzy-blog-list container
            blogList.innerHTML += articleHtml;
          });
        }
      } else {
        // console.error("Error: Unable to retrieve articles", data);
      }
    })
    .catch((error) => {
      // console.error("Error:", error);
    });
}
const html = document.querySelector("html");
function closeHeaderSearch(e) {
  const searchHeaderHost = document.querySelector(
    ".header-desktop header-search"
  );
  const desktopHeader = document.querySelector(".header-desktop header-search");
  const searchOverlay = searchHeaderHost.shadowRoot.querySelector('[part="overlay"]');

  if(desktopHeader && desktopHeader.hasAttribute("open") && searchOverlay) {
    desktopHeader.removeAttribute("open");
    searchOverlay.click();
  }
  html.classList.remove("lock");
}

if (window.innerWidth > 768) {
  const searchHeaderHost = document.querySelector(
    ".header-desktop header-search"
  );
  
  function handleCloseButton(e) {
    const button = e.target;
    const headerSearch = button.closest('.header-desktop header-search');
    if (!headerSearch) return;
    
    // console.log("CLICKED");
    const searchHeaderHost = document.querySelector(".header-desktop header-search");
    const searchOverlay = searchHeaderHost?.shadowRoot?.querySelector('[part="overlay"]');
    
    $('#header-search-sections--26366032904575__header').click();
    if (searchOverlay) {
      searchOverlay.click();
    }
    closeHeaderSearch(e);
  }

  document.addEventListener('dialog:force-close', handleCloseButton, true);

  if (searchHeaderHost?.shadowRoot) {
    const searchOverlay = searchHeaderHost.shadowRoot.querySelector('[part="overlay"]');
    if (searchOverlay) {
      searchOverlay.addEventListener("click", function (e) {
        searchOverlay.click();
      });
    }
  }
}

// function closeHeaderSearch(e) {
//   // e.preventDefault();
//   const searchHeaderHost = document.querySelector(
//     ".header-desktop header-search"
//   );
//   const desktopHeader = document.querySelector(".header-desktop header-search");
//   if(desktopHeader && desktopHeader.hasAttribute("open")) {
//     desktopHeader.removeAttribute("open");
//   }
//   // const autocomplete = document.querySelector(".wizzy-autocomplete-wrapper");
//   // autocomplete &&
//   //   autocomplete.style.setProperty("display", "none", "important");
//   // body.classList.remove("wizzy-autocomplete-opened");
//   html.classList.remove("lock");
// }

if (window.innerWidth > 768) {
  const closeButton = document.querySelector(
    '.header-desktop #predictive-search-form > div > button'
  );
  // const searchHeaderHost = document.querySelector(
  //   ".header-desktop header-search"
  // );
  
  // const searchOverlay = searchHeaderHost.shadowRoot.querySelector('[part="overlay"]');
  // if (searchOverlay) {
  //   searchOverlay.addEventListener("click", function (e) {
  //     closeHeaderSearch(e);
  //     searchOverlay.click();
  //   });
  // }
  
  
  // if (closeButton) {    
  //   closeButton.addEventListener("click", function (e) {
  //     $('#header-search-sections--26366032904575__header').click();
  //     searchOverlay.click();
  //     closeHeaderSearch(e);
  //   });
  // }

  closeButton.addEventListener('click', function(){
    // console.log("WIZZY", closeButton);
    closeButton.click();
  });

  
}

const searchIcon =
  window.innerWidth < 768
    ? document.querySelector(
        ".header-mobile .header__secondary-nav .icon-search"
      )
    : document.querySelector(
        ".header-desktop .header__secondary-nav [href='/search']"
      );

const searchInput =
  window.innerWidth < 768
    ? document.querySelector(
        ".wizzy-search-form-wrapper .wizzy-search-form #searchInput"
      )
    : document.querySelector(".header-desktop .header-search__input");
if (searchIcon) {
  searchIcon.addEventListener("click", (event) => {
    if (window.innerWidth < 768) {
      setTimeout(() => {
        searchInput?.click();
        searchInput?.click();
      }, 500);
    }

    if (window.innerWidth > 768) {
      setTimeout(() => {
        const drawer = document.querySelector(
          ".header-desktop .header-search .container"
        );
        const wizzyWrapper = document.querySelector(".wizzy-body-end-wrapper");
        if (drawer && wizzyWrapper) {
          drawer.appendChild(wizzyWrapper);
        }
      }, 500);
    }
    setTimeout(() => {
      searchInput?.click();
    }, 500);
  });
}

let varientMapper = {
  Beige:
    "https://universalpaving.co.uk/cdn/shop/files/Beige.png?crop=center&height=32&v=1755608621&width=32",
  Yellow: "",
  White:
    "https://universalpaving.co.uk/cdn/shop/files/White.png?crop=center&height=32&v=1755608644&width=32",
  Multi:
    "https://universalpaving.co.uk/cdn/shop/files/Multi.png?crop=center&height=32&v=1755608640&width=32",
  Buff: "https://universalpaving.co.uk/cdn/shop/files/Buff.png?crop=center&height=32&v=1755608631&width=32",
  Blue: "https://universalpaving.co.uk/cdn/shop/files/Blue.png?crop=center&height=32&v=1755608627&width=32",
  "Rustic-Slate":
    "https://universalpaving.co.uk/cdn/shop/files/Rustic_Slate_Porcelain_900x6004_3b0b8a65-5a11-4c27-b086-1dc76ab7d92d.png?crop=center&height=32&v=1755608530&width=32",
  "Gris-Anthracite":
    "https://universalpaving.co.uk/cdn/shop/files/Gris-anthracite_black_mix2.png?crop=center&height=32&v=1755608471&width=32",
  "Grey-Kandla":
    "https://universalpaving.co.uk/cdn/shop/files/Grey-kandla-grey-sawn-900x200-2.png?crop=center&height=32&v=1754996278&width=32",
  "Mint-Smooth": "",
  "Green-Rajgreen":
    "https://universalpaving.co.uk/cdn/shop/files/Green-Rajgreen_porcelain_900x6009_800909a2-904b-4493-90f6-4e30a490ab80.png?crop=center&height=32&v=1755580525&width=32",
  "Black-Anthracite":
    "https://universalpaving.co.uk/cdn/shop/files/black-anthracite_black_mix7.png?crop=center&height=32&v=1754979068&width=32",
  "Brown-Rustique":
    "https://universalpaving.co.uk/cdn/shop/files/Brown-Rustique_Outdoor_Porcelain_900x6002_6a8a17ca-e37c-4a82-a122-47aa3dc9bb3d.png?crop=center&height=32&v=1755580459&width=32",
  "Grey-Earth-Stone":
    "https://universalpaving.co.uk/cdn/shop/files/Grey-Earth-stone-grey-porcelain-outdooe-slabs-4.png?crop=center&height=32&v=1755608300&width=32",
  "Mint-Fossil":
    "https://universalpaving.co.uk/cdn/shop/files/Mint-Fossil_Mint-Riven-Mix-8.png?crop=center&height=32&v=1755606417&width=32",
};
function findHaxCode(key) {
  return varientMapper[key] ? [varientMapper[key], true] : [key, false];
}

function handleButtonClickForInstock(event) {
  event.stopPropagation();
  event.preventDefault();
  const currentURL = window.location.href;
  const updatedURL = updateURL(currentURL, "inStock[]", "true");
  window.executeWizzyFiltersFromURL(updatedURL);
}

function updateURL(url, key, value) {
  const urlObj = new URL(url);
  urlObj.searchParams.has(key)
    ? urlObj.searchParams.delete(key)
    : urlObj.searchParams.append(key, value);
  var newURL = urlObj.toString().replace(/%5B%5D/g, "[]");
  return newURL;
}

function gridFiltersToggleOnOverflow() {
  if (window.innerWidth > 768) {
    const filterBoxes = document.querySelectorAll(".wizzy-grid-filters-box");
    filterBoxes.length > 0 &&
      filterBoxes.forEach((box) => {
        const filterList = box.querySelector(
            ".wizzy-facet-body .wizzy-facet-list"
          ),
          toggleBtn = box.querySelector(".wizzy-facet-body .wizzy-toggle-btn"),
          filterOptions = box.querySelector(".wizzy-facet-body");
        if (
          filterList &&
          toggleBtn &&
          filterOptions &&
          !toggleBtn.classList.contains("wizzy-click-event-attached")
        ) {
          const filterHeight = filterList.offsetHeight,
            lineHeight = parseFloat(getComputedStyle(filterList).lineHeight);
          Math.floor(filterHeight / lineHeight) - 1 > 2
            ? (filterOptions.classList.add("collapsed"),
              toggleBtn.classList.add("wizzy-click-event-attached"),
              (toggleBtn.style.display = "inline-block"))
            : (toggleBtn.style.display = "none"),
            toggleBtn.addEventListener("click", function () {
              filterOptions.classList.contains("collapsed")
                ? (filterOptions.classList.remove("collapsed"),
                  filterOptions.classList.add("expanded"),
                  (toggleBtn.innerText = "- Less"))
                : (filterOptions.classList.remove("expanded"),
                  filterOptions.classList.add("collapsed"),
                  (toggleBtn.innerText = "+ More")),
                toggleBtn.classList.add("wizzy-click-event-attached");
            });
        }
      });
  }
}

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (payload) {
      window.wizzyConfig &&
        (window.matchMedia("(max-width: 768px)").matches
          ? (window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] =
              {
                dom: ".wizzy-search-form-wrapper #searchInput",
                type: "search",
              })
          : (window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] =
              {
                dom: ".header-desktop #searchInput",
                type: "search",
              }));
      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers[0] =
        "body main";
      window.wizzyConfig.filters.configs.layout = "v1";
      window.wizzyConfig.search.configs.pagination.appendInExistingList = true;
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
      payload.search.configs.facets.leftFacets.mobileCollapsible = true;
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      window.wizzyConfig &&
        (window.matchMedia("(max-width: 768px)").matches
          ? (window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] =
              {
                dom: ".wizzy-search-form-wrapper #searchInput",
                type: "search",
              })
          : (window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] =
              {
                dom: ".header-desktop #searchInput",
                type: "search",
              }));
      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers[0] =
        "body main";
      window.wizzyConfig.filters.configs.layout = "v1";
      window.wizzyConfig.search.configs.pagination.appendInExistingList = true;
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
      payload.search.configs.facets.leftFacets.mobileCollapsible = true;

      if (!sessionStorage.getItem("collectionLayout")) {
        if (window.innerWidth > 768) {
          sessionStorage.setItem("collectionLayout", "medium");
        } else {
          sessionStorage.setItem("collectionLayout", "medium");
        }
      }
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      // payload.minQueryLength = 1;
      //code to remove search drawer
      const closeBtn =
        window.innerWidth < 768
          ? document.querySelector(".wizzy-search-form .wizzy-search-back")
          : document.querySelector(
              '.header-desktop .header-search button[is="dialog-close-button"]'
            );
      if (closeBtn) {
        closeBtn.click();
      }

      const carouselWidget = document.querySelectorAll(
        ".CarouselWidget-prefix"
      );
      if (carouselWidget) {
        carouselWidget.forEach((el) => {
          el.style.display = "none";
        });
      }
      
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      if (data.filters) {
        if (data.filters.sort && data.filters.sort[0].field !== "relevance") {
          data.filters.showOOSProductsInOrder = "true";
        }
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {
      if (products) {
        products.forEach((product) => {
          let lowestVariantionForSellingPrice = null;
          let lowestVariantionForPrice = null;
          product.hasFromSellingPrice = false;
          if (product.attributes) {
            product.attributes.forEach((attr) => {
              if (attr.id === "product_handle") {
                product.handle = attr.values[0].value[0];
              }
              if (attr.id === "product_sku") {
                product.productSKUs = attr.values
                  ?.flatMap((item) => item.value)
                  .join(";");
              }
              if (attr.id === "product_badges_custom") {
                product.badge = attr.values[0].value[0];
              }
              if (
                window.wizzyConfig?.pageStore?.searchedResponse?.filters
                  ?.sort[0].field !== "sellingPrice"
              ) {
                if (
                  attr.id === "product_variant_prices" &&
                  attr.values.length > 1
                ) {
                  lowestVariantionForSellingPrice = attr.values.reduce(
                    (min, obj) => {
                      return obj.value[0] < min.value[0] ? obj : min;
                    }
                  );
                }
                if (attr.id === "product_variant_compare_at_prices") {
                  product.productVariantIDs = attr.values
                    ?.flatMap((item) => item.variationId)
                    .join(";");
                  if (attr.values.length > 1) {
                    lowestVariantionForPrice = attr.values.reduce(
                      (min, obj) => {
                        return obj.value[0] < min.value[0] ? obj : min;
                      }
                    );
                  }
                }
              }
            });

            if (lowestVariantionForSellingPrice) {
              product.hasFromSellingPrice = true;
              product.sellingPrice =
                lowestVariantionForSellingPrice.value[0] + ".00";
            }
            if (lowestVariantionForPrice) {
              product.price = lowestVariantionForPrice.value[0] + ".00";
            }
          }

          if(product.images) {
            const updatedImages = [];
            product.images.forEach((image,index) => {
              updatedImages.push({
                image : image,
                isFirst : index === 0 ? true : false
              });
            });
            product.shownImages = updatedImages;
          }
        });
      }
      return products;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (payload) {
      try {
        //close btn for sort by options
        if (window.innerWidth < 768) {
          const sortByCloseBtn = document.querySelector(
            ".wizzy-common-select-container .wizzy-common-select-options .wizzy-sort-header .wizzy-sort-by-close-btn"
          );
          if (sortByCloseBtn) {
            sortByCloseBtn.addEventListener("click", () => {
              const sortByOptions = document.querySelector(
                ".wizzy-common-select-container .wizzy-common-select-options"
              );
              const body = document.body;
              const html = document.querySelector("html");
              if (
                body &&
                html &&
                sortByOptions &&
                body.classList.contains("wizzy-overlay-opened") &&
                body.classList.contains("wizzy-common-select-body-overlay") &&
                html.classList.contains("wizzy-overlay-opened") &&
                html.classList.contains("wizzy-common-select-body-overlay")
              ) {
                body.classList.remove("wizzy-overlay-opened");
                body.classList.remove("wizzy-common-select-body-overlay");
                html.classList.remove("wizzy-overlay-opened");
                html.classList.remove("wizzy-common-select-body-overlay");
                sortByOptions.style.display = "none";
              }
            });
          }
        }
        // availability toggle button
        var inStockBtn = document.querySelector(
          ".facet-block-inStock #wizzy-search-filters-inStock-input"
        );
        inStockBtn &&
          inStockBtn.addEventListener("click", handleButtonClickForInstock);

        var instockValue = window.wizzyConfig?.pageStore?.searchedResponse?.filters?.inStock;
        if (instockValue && instockValue[0] === "true") {
          var inputForInstock = document.querySelector(
            ".facet-block-inStock #wizzy-search-filters-inStock-input"
          );
          var inputForInstockMobile = document.querySelector(
            ".wizzy-filters-facet-block.facet-block-inStock .wizzy-search-filters-toggle-input-class"
          );
          if(inputForInstock){
            inputForInstock.checked = true;
          } 
          // inputForInstockMobile &&
          //   inputForInstockMobile.setAttribute("checked", "");
        }

        // add product count
        if (payload.data.api == "search" || payload.data.api === "filter") {
          const productcountDiv = document.querySelector(
            ".collection-toolbar__products-count"
          );
          if (productcountDiv) {
            productcountDiv.innerHTML =
              payload.data.response.payload.total + " Products";
          }
        }

        //grid filter show more and show less button
        gridFiltersToggleOnOverflow();

        //code for price slider making sure it is intake at it's place
        var slider = document.querySelector(".wizzy-facet-range-slider");
        if (slider) {
          var sliderInstance = slider.noUiSlider;
          sliderInstance.updateOptions({
            margin: 100,
          });
        }

        const labels = document.querySelectorAll(
          '[data-facetkey="sellingPrice"] .facet-item-label-value'
        );
        const minToolTip = document.querySelector(
          ".noUi-handle-lower .noUi-tooltip"
        );
        const maxToolTip = document.querySelector(
          ".noUi-handle-upper .noUi-tooltip"
        );
        const wizzyMinRange = document.querySelector(
          ".wizzy-range-wrapper .wizzy-min-range"
        );
        const wizzyMaxRange = document.querySelector(
          ".wizzy-range-wrapper .wizzy-max-range"
        );

        if (minToolTip && maxToolTip) {
          wizzyMinRange.innerHTML = minToolTip.textContent;
          wizzyMaxRange.innerHTML = maxToolTip.textContent;

          const handleElement = document.querySelector(".noUi-handle");
          const observer = new MutationObserver(function (
            mutationsList,
            observer
          ) {
            for (let mutation of mutationsList) {
              if (
                mutation.attributeName === "aria-valuemax" ||
                mutation.attributeName === "aria-valuemin"
              ) {
                const minToolTip = document.querySelector(
                  ".noUi-handle-lower .noUi-tooltip"
                );
                const maxToolTip = document.querySelector(
                  ".noUi-handle-upper .noUi-tooltip"
                );
                const wizzyMinRange = document.querySelector(
                  ".wizzy-range-wrapper .wizzy-min-range"
                );
                const wizzyMaxRange = document.querySelector(
                  ".wizzy-range-wrapper .wizzy-max-range"
                );

                wizzyMinRange.innerHTML = minToolTip.textContent;
                wizzyMaxRange.innerHTML = maxToolTip.textContent;
              }
            }
          });
          const observerConfig = { attributes: true };
          observer.observe(handleElement, observerConfig);
        }

        //code to fetch pages
        if (
          payload.data.api === "search" ||
          (payload.data.api === "filter" &&
            payload.data.response.payload.filters.page === 1 &&
            payload.data.response.payload.filters.page !==
              "AUTOCOMPLETE_DEFAULT")
        ) {
          var queryHit = payload.data.response.payload.filters.q;
          let hasNextPage = true;
          let nextPageCursor = null;
          // console.log(queryHit);
          fetchPages(queryHit);
          fetchArticles(queryHit);
        }

        //code to attach click events to top tab button for search page and empty search page
        const tabs = document.querySelectorAll(".wizzy-st-single-tab");
        const sections = {
          "products-tab": [
            document.querySelector("height-observer.collection-toolbar"),
            document.querySelector(".wizzy-search-wrapper"),
            document.querySelector(".wizzy-search-empty-results-wrapper"),
          ],
          "blogs-tab": [document.querySelector(".wizzy-blog-wrapper")],
          "pages-tab": [document.querySelector(".wizzy-page-wrapper")],
        };
        function hideAllSections() {
          Object.values(sections)
            .flat()
            .forEach((el) => {
              if (el) el.style.display = "none";
            });
        }
        tabs.forEach((tab) => {
          tab.addEventListener("click", () => {
            tabs.forEach((t) => t.classList.remove("st-active"));
            tab.classList.add("st-active");
            hideAllSections();

            const key = Array.from(tab.classList).find((cls) =>
              ["products-tab", "blogs-tab", "pages-tab"].includes(cls)
            );
            if (sections[key]) {
              sections[key].forEach((el) => {
                if (el) el.style.display = "flex";
              });
            }
          });
        });
        hideAllSections();
        sections["products-tab"].forEach(
          (el) => el && (el.style.display = "flex")
        );

        //apply button code
        const filterApplyBtn = document.querySelector(
          ".wizzy-mobile-filter-buttons-v1 .wizzy-apply-all-button"
        );
        const filterOverlay = document.querySelector(".wizzy-filters-bg");

        if (filterApplyBtn) {
          filterApplyBtn.addEventListener("click", () => {
            if (filterOverlay) filterOverlay.click();
          });
        }

        //show summary for mobile view through code
        if (
          window.innerWidth < 768 &&
          (payload.data.api === "search" ||
            (payload.data.api === "filter" &&
              payload.data.response.payload.filters.type === "DEFAULT"))
        ) {
          const summaryHeading = document.querySelector(
            ".wizzy-header-topbar .prose.text-center"
          );

          if (summaryHeading) {
            const headingEle = summaryHeading.querySelector(".h1");
            if (headingEle) {
              total = payload?.data?.response?.payload?.total;
              headingEle.innerHTML = `${total} Search Results for "<b>${payload?.data?.response?.payload?.filters?.q}</b>"`;
            }
          }
        }

        if (
          payload.data.api === "search" ||
          (payload.data.api === "filter" &&
            payload.data.response.payload.filters.type === "DEFAULT")
        ) {
          const productGridEle = document.querySelector(
            ".wizzy-search-results .product-list"
          );
          const productGridLayout = sessionStorage.getItem("collectionLayout");
          if (productGridEle) {
            if (productGridLayout) {
              window.innerWidth > 768
                ? productGridEle.setAttribute(
                    "collection-desktop-layout",
                    productGridLayout
                  )
                : productGridEle.setAttribute(
                    "collection-mobile-layout",
                    productGridLayout
                  );

               const activeButton = document.querySelector(
                `collection-layout-switch[device="${window.innerWidth > 768 ? "desktop" : "mobile"}"] button[value="${productGridLayout}"]`
              );

              if (activeButton) {
                activeButton.classList.add("is-active");
              }
            }
          }
          //code for making sure product grid doesn't change
          const layoutSwitchButtons = document.querySelectorAll(
            'collection-layout-switch[device="desktop"] button[value], collection-layout-switch[device="mobile"] button[value]'
          );

          layoutSwitchButtons.forEach((button) => {
            button.addEventListener("click", () => {
              const layoutValue = button.getAttribute("value");
              sessionStorage.setItem("collectionLayout", layoutValue);

              // layoutSwitchButtons.forEach((btn) => btn.classList.remove("is-active"));
              // button.classList.add("is-active");
            });
          });

          //code for init rating
          ratingSnippet("ruk_rating_snippet", {
            store: "www.universalpaving.co.uk",
            color: "#0E1311",
            usePolaris: true,
            text: "Reviews",
          });
        }
      } catch (error) {
        // console.log(error);
      }

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      // payload.minQueryLength = 1;
      if (payload && prohibitedWords.includes(payload.q.toLowerCase())) {
          payload.q = "abcdefghija";
      }
      return payload;
  });

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (data) {
      var facets = data.response.payload.facets;
      facets.forEach((facet) => {
        if (facet.key === "colors") {
          facet.data.forEach((item) => {
            let [haxcode, isURLSwatch] = findHaxCode(item.key);
            item.isSwatch = true;
            item.isURLSwatch = isURLSwatch;
            item.isVisualSwatch = true;
            item.swatchValue = haxcode;
            item.data = {
              value: item.key,
              swatch: {
                type: "visual",
                value: haxcode,
              },
            };
          });
        }
      });

      //append grid filters
      if (
        window.wizzyConfig &&
        window.wizzyConfig.gridFilters &&
        Array.isArray(window.wizzyConfig.gridFilters.filters) &&
        window.wizzyConfig.gridFilters.filters.length > 0
      ) {
        let totalCount = data.response.payload.total;
        let gridFilters = window.wizzyConfig.gridFilters.filters;

        let lastMobilePosition =
          gridFilters[gridFilters.length - 1].after.mobile;
        let lastWebPosition = gridFilters[gridFilters.length - 1].after.web;

        let webIncrement = 12;
        let mobileIncrement = 12;

        if (totalCount > lastMobilePosition) {
          let newFilters = [];

          let currentWebPosition = lastWebPosition;
          let currentMobilePosition = lastMobilePosition;

          while (currentMobilePosition < totalCount) {
            gridFilters.forEach((filter) => {
              currentWebPosition += webIncrement;
              currentMobilePosition += mobileIncrement;
              let newFilter = { ...filter };
              newFilter.after = {
                web: currentWebPosition,
                mobile: currentMobilePosition,
              };
              newFilters.push(newFilter);
            });
          }
          window.wizzyConfig.gridFilters.filters = [
            ...gridFilters,
            ...newFilters,
          ];
        }
      }


      // const prohibitedWords = ["bitch","blood","bloody", "illegal","black market","unlicensed","counterfeit","smuggle","smuggling","weapon","violence","riot","fraudulent","shit"];
      if (data.api === "search" && data.response && data.response.payload.filters) {
        const filterQuery = data.response.payload.filters.q.toLowerCase();
        if (prohibitedWords.includes(filterQuery)) {
            data.error = true;
        }
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (payload) {
      // availability toggle button
      var inStockBtn = document.querySelector(
        ".wizzy-search-filters-inStock-input"
      );
      inStockBtn &&
        inStockBtn.addEventListener("click", handleButtonClickForInstock);

      //grid filter show more and show less button
      gridFiltersToggleOnOverflow();

      //code for price slider making sure it is intake at it's place
      var slider = document.querySelector(".wizzy-facet-range-slider");
      if (slider) {
        var sliderInstance = slider.noUiSlider;
        sliderInstance.updateOptions({
          margin: 100,
        });
      }

      const labels = document.querySelectorAll(
        '[data-facetkey="sellingPrice"] .facet-item-label-value'
      );
      const minToolTip = document.querySelector(
        ".noUi-handle-lower .noUi-tooltip"
      );
      const maxToolTip = document.querySelector(
        ".noUi-handle-upper .noUi-tooltip"
      );
      const wizzyMinRange = document.querySelector(
        ".wizzy-range-wrapper .wizzy-min-range"
      );
      const wizzyMaxRange = document.querySelector(
        ".wizzy-range-wrapper .wizzy-max-range"
      );

      if (minToolTip && maxToolTip) {
        wizzyMinRange.innerHTML = minToolTip.textContent;
        wizzyMaxRange.innerHTML = maxToolTip.textContent;

        const handleElement = document.querySelector(".noUi-handle");
        const observer = new MutationObserver(function (
          mutationsList,
          observer
        ) {
          for (let mutation of mutationsList) {
            if (
              mutation.attributeName === "aria-valuemax" ||
              mutation.attributeName === "aria-valuemin"
            ) {
              const minToolTip = document.querySelector(
                ".noUi-handle-lower .noUi-tooltip"
              );
              const maxToolTip = document.querySelector(
                ".noUi-handle-upper .noUi-tooltip"
              );
              const wizzyMinRange = document.querySelector(
                ".wizzy-range-wrapper .wizzy-min-range"
              );
              const wizzyMaxRange = document.querySelector(
                ".wizzy-range-wrapper .wizzy-max-range"
              );

              wizzyMinRange.innerHTML = minToolTip.textContent;
              wizzyMaxRange.innerHTML = maxToolTip.textContent;
            }
          }
        });
        const observerConfig = { attributes: true };
        observer.observe(handleElement, observerConfig);
      }

      //code to fetch pages
      // if (
      //   payload.data.api === "search" ||
      //   (payload.data.api === "filter" &&
      //     payload.data.response.payload.filters.page === 1 &&
      //     payload.data.response.payload.filters.page !== "AUTOCOMPLETE_DEFAULT")
      // ) {
      //   var queryHit = payload.data.response.payload.filters.q;
      //   let hasNextPage = true;
      //   let nextPageCursor = null;
      //   console.log(queryHit);
      //   fetchPages(queryHit);
      // }

      //code to attach click events to top tab button for search page and empty search page
      const tabs = document.querySelectorAll(".wizzy-st-single-tab");
      const pageWrapper = document.querySelector(".wizzy-page-wrapper");
      const searchResultsWrapper = document.querySelector(
        ".wizzy-search-results-wrapper"
      );
      const collectionToolbar = document.querySelector(
        ".wizzy-header-topbar .collection-toolbar"
      );

      tabs.forEach((tab) => {
        tab.addEventListener("click", function () {
          tabs.forEach((t) => t.classList.remove("st-active"));
          this.classList.add("st-active");
          if (this.classList.contains("products-tab")) {
            searchResultsWrapper.style.display = "flex";
            if (collectionToolbar) {
              collectionToolbar.style.display = "flex";
            }
            pageWrapper.style.display = "none";
          } else if (this.classList.contains("pages-tab")) {
            pageWrapper.style.display = "block";
            searchResultsWrapper.style.display = "none";
            if (collectionToolbar) {
              collectionToolbar.style.display = "none";
            }
          }
        });
      });
      return payload;
    }
  );
};
